export const campaignBranding = {
    alphaValues: [
        { ex: '65', value: 0.65 },
        { ex: '08', value: 0.08 },
        { ex: '5', value: 0.5 },
    ],
    fonts: {
        font_title: "'HeinekenSerif18', sans-serif",
        font_body: "'HeinekenSerif18', sans-serif",
        font_button: "'HeinekenCore', sans-serif",
    },
};
